import { CoreApi } from '@framework/utils/core-api';
import { API_ENDPOINTS } from '@framework/utils/endpoints';
import { ProductsPaginationQueryOptionsType } from '@framework/types';

class Product extends CoreApi {
  constructor(_base_path: string) {
    super(_base_path);
  }

  all(params: ProductsPaginationQueryOptionsType) {
    const {page, limit, type, categoryId, sortPrice, shopId, parentId, childrenId, ids, productId, searchTextShop, seed } = params;
    return this.http.get(this._base_path, {
      params: {
        page: page || 1,
        limit: limit || API_ENDPOINTS.DEFAULT_PRODUCTS_PER_PAGE,
        type,
        sortPrice,
        shopId: shopId || '',
        categoryId: categoryId || '',
        // cate_parent: parentId || '',
        cate_child: childrenId || '',
        categoryIds: (ids || []).join(", "),
        productId: productId || '',
        keywords: searchTextShop || '',
        seed: seed || '',
      }
    })
    .then((res) => res.data)
    .catch(() => []);
  }

  voteWishlistsProduct(input: {product_id: string | number;}) {
    return this.http
      .post(API_ENDPOINTS.VOTE_WISHLISTS_PRODUCT, input)
      .then((res) => res.data);
  }

  fetchProductIds(ids: any, locale: string) {
    return this.http
      .get(API_ENDPOINTS.FETCH_PRODUCT_IDS, {
        params: { ids }
      })
      .then((res) => res.data);
  }

  fetchRelatedProducts(params: {id: string, limit: number, locale: string}) {
    const {id, limit, locale} = params;

    return this.http.get(`${this._base_path}/${id}`, {
      params: { limit }
    })
    .then((res) => res.data)
    .catch(() => []);
  }

  fetchRelatedCategoryProducts(params: {id: string, limit: number, locale: string}) {
    const {id, limit, locale} = params;

    return this.http.get(`${this._base_path}/${id}`, {
      params: { limit }
    })
    .then((res) => res.data)
    .catch(() => []);
  }
}

export const ProductHotAkcesService = new Product(API_ENDPOINTS.FETCH_HOT_PRODUCTS);
export const BestProductsService = new Product(API_ENDPOINTS.FETCH_BEST_PRODUCTS);
export const BestHomeProductsService = new Product(API_ENDPOINTS.FETCH_BEST_HOME_PRODUCTS);
export const NewProductsService = new Product(API_ENDPOINTS.FETCH_NEW_PRODUCTS);
export const BestSellerProductsService = new Product(API_ENDPOINTS.FETCH_BEST_SELLER_PRODUCTS)
export const ShopProductsService = new Product(API_ENDPOINTS.FETCH_SHOP_PRODUCTS)
export const FavoritesProductsService = new Product(API_ENDPOINTS.FETCH_WISHLISTS_PRODUCTS)
export const ProductCommonService = new Product('products')
export const RelatedProductShopsService = new Product(API_ENDPOINTS.FETCH_RELATED_PRODUCT_SHOPS);
export const ProductRelatedByIdService = new Product(API_ENDPOINTS.GET_PRODUCT_RELATED_BY_ID);
export const ProductRelatedByCateIdService = new Product(API_ENDPOINTS.GET_PRODUCT_BY_CATEIDS);
export const BestProductsShopService = new Product(API_ENDPOINTS.FETCH_BEST_PRODUCTS_SHOP);
